import { Link } from "react-router-dom";
import logo from "@/assets/logo.jpeg";
import { MessageCircle, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-gold-dark/20 bg-card/50 py-12">
      <div className="container mx-auto px-4">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2">
              <img src={logo} alt="Prime Profit logo" className="h-10 w-auto rounded" />
              <span className="font-display text-base font-bold gradient-gold-text">PRIME PROFIT</span>
            </div>
            <p className="mt-3 text-xs text-muted-foreground font-body">
              Strategic BTC & BNB trading cycles with secure account management and transparent reporting.
            </p>
          </div>

          {/* Company */}
          <div>
            <h2 className="font-display text-sm font-semibold text-gold">Company</h2>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground font-body">
              <li><Link to="/about" className="hover:text-gold transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="hover:text-gold transition-colors">FAQ</Link></li>
              <li><Link to="/how-it-works" className="hover:text-gold transition-colors">How It Works</Link></li>
              <li><Link to="/login" className="hover:text-gold transition-colors">Login</Link></li>
              <li><Link to="/register" className="hover:text-gold transition-colors">Register</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h2 className="font-display text-sm font-semibold text-gold">Legal</h2>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground font-body">
              <li><Link to="/terms" className="hover:text-gold transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link></li>
              <li><Link to="/disclaimer" className="hover:text-gold transition-colors">Risk Disclosure</Link></li>
              <li><Link to="/cookies" className="hover:text-gold transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h2 className="font-display text-sm font-semibold text-gold">Contact</h2>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground font-body">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-gold/70" aria-hidden="true" />
                <a href="mailto:primeprofitsemail@webname.com" className="hover:text-gold transition-colors">
                  primeprofitsemail@webname.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle className="h-4 w-4 text-gold/70" aria-hidden="true" />
                <a href="https://t.me/officialprimeprofit" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">
                  Telegram Chat
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle className="h-4 w-4 text-gold/70" aria-hidden="true" />
                <a href="https://t.me/primeprofit_channel" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">
                  Telegram Channel
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-gold-dark/20 pt-6 text-center">
          <p className="text-xs text-muted-foreground font-body">
            © {new Date().getFullYear()} Prime Profit. All rights reserved.
          </p>
          <p className="mt-2 text-xs text-muted-foreground/80 font-body">
            Trading digital assets involves risk. Please read our{" "}
            <Link to="/disclaimer" className="text-gold hover:underline">Risk Disclosure</Link> before investing.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
